import React from 'react';
import classnames from 'classnames';
import { compact } from 'lodash';
import { CheckCircle } from 'react-feather';

import StrapiButton from '../StrapiLink/StrapiButton';
import { DeliveryMethodFragment, LinkComponentFragment } from '../../../graphql.schema';
import StrapiLink from '../StrapiLink/StrapiLink';

import * as styles from './PricingPanel.module.scss';

type PricingPanelFragment = DeliveryMethodFragment & {
  showFeatures?: boolean;
  showPrice?: boolean;
  learnMoreLink?: LinkComponentFragment;
};

const PricingPanel = ({
  pricingPlanHeading,
  pricingPlanDescription,
  features,
  bannerText,
  isRecommended = false,
  showFeatures = true,
  showPrice = true,
  link,
  learnMoreLink,
  footnote,
  price,
}: PricingPanelFragment) => (
  <div className={styles.root}>
    {isRecommended ? (
      <div className={styles.bannerWrapper}>
        <p className={styles.bannerText}>{bannerText}</p>
      </div>
    ) : null}
    <h3 className="title is-3">{pricingPlanHeading}</h3>
    <p className={classnames('is-text-2 black-2 mb-5')}>{pricingPlanDescription}</p>
    {showFeatures ? (
     <ul className={styles.featuresList}>
     {compact(features).map(({ content, isFaded }, i) => (
       <li
         key={`pricing-panel-feature-${i}`}
         className={classnames('is-text-3', styles.listItem, {
           [styles.faded]: isFaded,
         })}
       >
         <CheckCircle size={20} className={classnames(styles.check, 'black-3 ml-1 has-text-weight-bold')} />
         {content}
       </li>
     ))}
   </ul>
    ) : null}
    {/* TODO: Removed links since this will link to a "learn more" type of destination
            which needs to be passed from a separate wrapper */}
    {learnMoreLink ? <StrapiLink {...learnMoreLink} /> : null}

    <hr className={styles.divider} />
    {showPrice && price ? (
      <div className={styles.price}>
        {price.label ? <span className={classnames('is-text-2', styles.priceLabel)}>{price.label}</span> : null}
        <span className={styles.priceAmount}>{price.price}</span>
        {price.frequency ? (
          <span className={classnames(styles.priceFrequency, 'is-text-3')}>/{price.frequency}</span>
        ) : null}
      </div>
    ) : null}

    {/* Buttons should support hubspot modals */}
    {link ? <StrapiButton className="mb-4" type={isRecommended ? 'primary' : 'secondary'} {...link} /> : null}
    {footnote ? <p className={styles.footnote}>{footnote}</p> : null}
  </div>
);

export default PricingPanel;
